export enum RecordStatus {
  PENDING_DELETION = 'Pending Deletion',
  DELETED = 'Deleted',
  RECOVERED = 'Recovered',
}

export enum Directory {
  SHARED_IN = 'SharedIn',
  SHARED_OUT = 'SharedOut',
  TRASH = 'Trash',
  DELETED = 'Deleted',
  PARTICIPANTS = 'Participants',
  FOLLOWERS = 'Followers',
  COMPARE = 'compare',
  NONE = '',
  INTERNAL = 'Internal',
}

export enum ViewType {
  ROW = 'row',
  COLUMN = 'column',
}
